import RequestService from '@/services/RequestService';
import Constants from '@/services/Constants.js';

const addLogLogin = (id_usuario) => {

    const options = {
        request: {
            url: Constants.api.log_login,
            payload: { idUsuario: id_usuario }
        },     
    };

    try {
        RequestService().putRequest(options);
    } catch (error) {
        console.log(error);
    }

}

export { addLogLogin };